import FilterListIcon from '@mui/icons-material/FilterList';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';

export type FilterButtonProps = ButtonProps;

export const FilterButton: React.FC<FilterButtonProps> = ({
  label,
  color = 'secondary',
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Button
      color={color}
      label={label || translate('app.buttons.filter')}
      startIcon={<FilterListIcon />}
      {...restProps}
    />
  );
};
